import { render, staticRenderFns } from "./salairedash.vue?vue&type=template&id=9695f724&"
import script from "./salairedash.vue?vue&type=script&lang=js&"
export * from "./salairedash.vue?vue&type=script&lang=js&"
import style0 from "./salairedash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports